<template>
  <div class="rt-approval-item">
    <rt-icon :name="iconName" size="20"></rt-icon>
    <div class="rt-approval-item-middle">
      <p class="title">{{ title }}</p>
      <p class="status">{{ status }}</p>
    </div>
    <p class="time">{{ time }}</p>
  </div>
</template>
<script>
export default {
  name: 'RtApprovalItem',
  props: {
    iconName: String,
    title: String,
    status: String,
    time: String
  }
};
</script>



// WEBPACK FOOTER //
// rtApprovalItem.vue?1ddc20e5